import type { AriaAttributes } from 'react';

export enum Platform {
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
}

export interface Host {
    protocol?: 'https';
    host: string;
    port?: string;
}

/**
 * DOM-атрибуты вида `aria-...` и `data-...`
 */
export interface ServiceAttributes extends AriaAttributes {
    [K: `data-${string}${string}`]: string;
}

export interface RequiredHosts {
    staff: Host;
    center: Host;
}
export type OptionalHosts = Record<string, Host>;
export type Hosts = RequiredHosts & OptionalHosts;
export type RequiredHostsKeys = keyof RequiredHosts;
export type GetHostFn = <T extends RequiredHostsKeys | string>(
    key: T,
) => T extends RequiredHostsKeys ? Host : Host | undefined;
export type FormatUrlFn = (host: Host, pathname: string, query?: Record<string, string>) => string;
